import { AVM_TUNE_TYPES } from '../../constants/valuation'

const CMA = AVM_TUNE_TYPES.CMA
const TYV = AVM_TUNE_TYPES.TYV

// TODO: test this
class ValuationHistorySegmentSerializer {
  static process(segment) {
    let _this = this
    let segmentInfo

    if (_this.segmentIncludesValuation(segment)) {
      segmentInfo = {
        count: segment.length,
        source: _this.sourceFor(_this.filteredValuation(segment)),
        valuations: _this.valuationsForDiffableSegment(segment)
      }
    } else {
      segmentInfo = {
        count: segment.length,
        source: {},
        valuations: _this.valuationsForSegment(segment)
      }
    }

    return segmentInfo
  }

  static valuationsForSegment(segment) {
    let _this = this

    return segment.map(function (valuation) {
      return _this.Valuation(valuation)
    })
  }

  static valuationsForDiffableSegment(segment) {
    let diff = this.filteredValuation(segment).diff
    let _this = this

    return segment.map(function (valuation) {
      if ([CMA, TYV].includes(valuation.valuationType)) return _this.Valuation(valuation)

      return _this.DiffedValuation(valuation, diff)
    })
  }

  static Valuation(valuation) {
    return {
      date: valuation.date,
      id: valuation.id,
      type: valuation.valuationType,
      valuation: valuation.amount
    }
  }

  static DiffedValuation(valuation, diff) {
    return {
      date: valuation.date,
      id: valuation.id,
      type: valuation.valuationType,
      valuation: valuation.amount + diff
    }
  }

  static filteredValuation(segment) {
    return segment.filter(valuation => [CMA, TYV].includes(valuation.valuationType))[0]
  }

  static segmentIncludesValuation(segment) {
    return segment.some(valuation => [CMA, TYV].includes(valuation.valuationType))
  }

  static sourceFor(valuation) {
    return {
      displayName: valuation.source && valuation.source.displayName,
      photoUrl: valuation.source && valuation.source.photoUri,
      type: valuation.source && valuation.source.type
    }
  }
}

export function buildSegments(history = []) {
  let valuationIndexes = []

  const filteredHistory = history.filter(valuation => valuation.amount !== 0)

  filteredHistory.forEach(function (record, i) {
    if ([CMA, TYV].includes(record.valuationType)) {
      valuationIndexes.push(i)
    }
  })

  valuationIndexes.push(filteredHistory.length)

  let segmentIndexes = []

  valuationIndexes.forEach(function (valuationIndex, i) {
    // First valuationIndex
    if (i === 0) {
      return segmentIndexes.push([0, valuationIndex])
    }

    // Last valuationIndex
    if (i === valuationIndexes.length - 1) {
      return segmentIndexes.push([valuationIndexes[i - 1], filteredHistory.length])
    }

    // All other valuationIndexes
    return segmentIndexes.push([valuationIndexes[i - 1], valuationIndexes[i]])
  })

  let segments = []

  segmentIndexes.forEach(function (range) {
    segments.push(filteredHistory.slice(range[0], range[1]))
  })

  let serializedSegments = segments.map(function (segment) {
    return ValuationHistorySegmentSerializer.process(segment)
  })

  return serializedSegments
}
